module.exports = __webpack_public_path__ + "static/media/arrow_preview.38f16a70.svg";